export class Kyc {
  constructor (govtIdName) {
    this.id = null
    this.govtIdName = govtIdName
    this.govtIdNumber = ''
    // this.govtIdScanUrl = ''
    // this.govtIdUrl = ''
  }
}



// WEBPACK FOOTER //
// ./src/models/Kyc.js